/**
 * Created by Languagenut on 19/06/2019.
 */

import React  from 'react';
import {Col , Row , Modal , Button} from 'react-bootstrap'
import Translation from  '../../store/internationalization-store.js';

export default class TextPopup extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        console.log(this.props);

        this.state = {
            value:this.props.value || ""
        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.state = {
            value:this.props.value || ""
        };
    }

    onSave(){
        console.log(this.props)
        if(this.props.onSave) this.props.onSave();
        this.props.onHide();
    }

    render() {
        var singleHide = this.props.onHide;
        if (this.props.onSave != undefined) {
            singleHide = this.props.onSave;
        }
        var button1 =  [<Button  onClick={this.props.onHide.bind(this)}>{Translation.get(12290, "No")}</Button>,
        <Button onClick={this.onSave.bind(this)}>{Translation.get(12289, "Yes")}</Button>]
        if (this.props.oneButton == true) {
            if (this.props.buttonTitle == undefined) {
                button1 =  <Button  onClick={singleHide.bind(this)}>{Translation.get(495, "Ok")}</Button>
            } else {
                button1 =  <Button  onClick={singleHide.bind(this)}>{Translation.get(-1, this.props.buttonTitle)}</Button>
            }
        }
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {this.props.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="strong">
                        <Col md={12}>
                            {this.props.body}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    {button1}
                </Modal.Footer>
            </Modal>
        );
    }
}